export class FiltrosModel{
    nombre;
    valor;
    check
    constructor(nombre, valor){
        this.nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1).toLowerCase()
        this.valor = valor
    }
}